import { axiosClient, getCSRFToken } from 'www/utils'
import type {
  ApiFamilyProfilesParamsPatch,
  ApiFamilyProfilesParamsPost,
  ApiFamilyProfilesParamsGet,
  ApiFamilyProfilesResponseGet,
} from 'www/vue_components/common/FamilyProfiles/api/apiFamilyProfiles.type'

export default {
  async get(params: ApiFamilyProfilesParamsGet): Promise<ApiFamilyProfilesResponseGet> {
    return axiosClient.get('/ajax/medtochka/patient/profile/family/', {
      params,
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
      timeout: 5000,
    }).then(({ data }) => data)
  },
  async post(params: ApiFamilyProfilesParamsPost): Promise<{ uuid: string | null }> {
    return axiosClient.post('/ajax/medtochka/patient/profile/family/', params, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
      timeout: 5000,
    }).then(({ data }) => data)
  },
  async patch(params: ApiFamilyProfilesParamsPatch) {
    return axiosClient.patch('/ajax/medtochka/patient/profile/family/', params, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
      timeout: 5000,
    })
  },
}
